import { call, put, select, takeEvery } from 'redux-saga/effects'

import analyticsActions from 'models/Analytics/actions'
import { getAnalyticsUserId } from 'models/Analytics/selectors'
import setUserId from 'services/analytics/setUserId'

export function* updateAnalyticsUserId({ payload }) {
  const { accountId } = payload
  if (!accountId) {
    return
  }
  const analyticsUserId = yield select(getAnalyticsUserId)
  if (analyticsUserId) {
    return
  }
  yield call(setUserId, accountId)
  yield put(analyticsActions.updateAnalyticsUserId.success(accountId))
}

function* main() {
  yield takeEvery(analyticsActions.updateAnalyticsUserId.INIT_TYPE, updateAnalyticsUserId)
}

export default {
  updateAnalyticsUserId,
  main,
}
